import React from 'react';
import PropTypes from 'prop-types';

import {
  getOfferingLegalText,
  STARTENGINE_OFFERING_DISCLOSURE_LINKS,
} from 'utils/offerings/helpers';

const linkStyle = { color: 'inherit', textDecoration: 'underline' };

const DisclosureLink = ({ href, children }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" style={linkStyle}>
    {children}
  </a>
);

DisclosureLink.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

const OfferingLegalText = ({ offeringData, isTtw = false }) => {
  if (offeringData?.slug?.toLowerCase() !== 'startengine') {
    return getOfferingLegalText(offeringData, { isTtw });
  }

  return (
    <>
      This Reg A+ offering is made available through StartEngine, Inc. No broker-dealer or
      intermediary involved in offering. This investment is speculative, illiquid, and involves a
      high degree of risk, including the possible loss of your entire investment. For more
      information, please see the most recent{' '}
      <DisclosureLink href={STARTENGINE_OFFERING_DISCLOSURE_LINKS.offeringCircular}>
        Offering Circular
      </DisclosureLink>{' '}
      and{' '}
      <DisclosureLink href={STARTENGINE_OFFERING_DISCLOSURE_LINKS.riskFactors}>
        Risk Factors
      </DisclosureLink>{' '}
      related to this offering, or StartEngine&apos;s{' '}
      <DisclosureLink href={STARTENGINE_OFFERING_DISCLOSURE_LINKS.edgarPage}>
        Edgar page
      </DisclosureLink>{' '}
      to review our latest financials.
    </>
  );
};

OfferingLegalText.propTypes = {
  offeringData: PropTypes.shape({
    slug: PropTypes.string,
  }),
  isTtw: PropTypes.bool,
};

export default OfferingLegalText;
